import React from 'react';

const Error = () => <>Error</>;


export default Error;
